import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RealUserGuard implements CanActivate {
  constructor(private userIdService: UserIdService) {}

  canActivate(): Observable<boolean> {
    return this.userIdService.isEmulated().pipe(map((isEmulated) => !isEmulated));
  }
}
